import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=2c8788b6&scoped=true&"
import script from "./navbar.vue?vue&type=script&lang=js&"
export * from "./navbar.vue?vue&type=script&lang=js&"
import style0 from "./navbar.vue?vue&type=style&index=0&id=2c8788b6&lang=scss&scoped=true&"
import style1 from "./navbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8788b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VAppBarNavIcon,VTab,VTabs})
